import { useState } from 'react';
import { Link as LinkIcon } from 'lucide-react';
import { toast } from 'sonner';

/**
 * AddLinkButton — minimal inline action that lets users attach an
 * EXTERNAL url (Drive link, S3, vendor site, etc.) anywhere there's
 * an upload button. The parent owns persistence: we just prompt for
 * URL + label and hand them back via `onAdd({ url, label })`.
 *
 * Why: many license/permit/manual PDFs already live in shared drives
 * — the GM wanted a way to attach them without re-uploading bytes.
 */
export default function AddLinkButton({ onAdd, label = 'Add link', testid = 'add-link-btn', disabled = false }) {
  const [busy, setBusy] = useState(false);
  return (
    <button
      type="button"
      data-testid={testid}
      disabled={disabled || busy}
      onClick={async () => {
        const url = window.prompt('Paste the full URL (https://…)', 'https://');
        if (!url || !/^https?:\/\//i.test(url.trim())) {
          if (url) toast.error('That doesn\'t look like a valid URL.');
          return;
        }
        const lbl = window.prompt('Short label to display:', '');
        if (lbl === null) return;
        setBusy(true);
        try { await onAdd?.({ url: url.trim(), label: (lbl || '').trim() || url.trim() }); }
        finally { setBusy(false); }
      }}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[11px] font-bold transition disabled:opacity-50"
      style={{ backgroundColor: '#EAF2FF', color: '#003DA5', border: '1px solid #C9D6E6', fontFamily: 'Manrope' }}
    >
      <LinkIcon className="w-3 h-3" /> {label}
    </button>
  );
}
